<template>
  <div id="contenedor-solicitudes-obras-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar  titulo="Solicitudes de Autorización de Obras">
            <template v-slot:opciones-derecha>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :to="{ name: 'obrasSolicitudesConfiguracionFirmas' }"
                    icon
                    v-bind="attrs"
                    v-on="on">
                    <v-icon> mdi-cog-outline </v-icon>
                  </v-btn>
                </template>
                <span> Configuración </span>
              </v-tooltip>
            </template>
            </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:agregarSolicitudObra="registrarNuevaSolicitudObra"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <listado
            :listadoSolicitudesObras="getListadoSolicitudesObras"
            :firma="getFirmaSolicitudObra">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- Ventana Agregar Solicitud Obra -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaSolicitudObra"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'"
      persistent
      scrollable>
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nueva solicitud de obra
          <v-spacer></v-spacer>
          <v-btn icon @click="$refs.registrarSolicitudObra.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <agregar-solicitud-obra
            v-if="mostrarVentanaRegistrarNuevaSolicitudObra"
            ref="registrarSolicitudObra"
            @formularioValido="setFormularioValido"
            @enviandoFormulario="setEnviandoFormulario"
            v-on:cerrar="cerrarVentana">
          </agregar-solicitud-obra>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="$refs.registrarSolicitudObra.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.registrarSolicitudObra.mixAgregarSolicitudObra()"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Ventana Editar Solicitud Obra -->
    <v-dialog
      v-if="estaSolicitudObra"
      v-model="mostrarVentanaEditarSolicitudObra"
      :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'"
      scrollable
      persistent>
      <v-card>
        <v-card-title class="secondary--text">
          Editar solicitud de obra
          <v-spacer></v-spacer>
          <v-btn icon @click="$refs.editarSolicitudObra.cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <editar-solicitud-obra
        ref="editarSolicitudObra"
        :solicitudObraEditar="estaSolicitudObra"
        @formularioValido="setFormularioValido"
        @enviandoFormulario="setEnviandoFormulario"
        v-on:cerrar="cerrarVentana">
      </editar-solicitud-obra>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="$refs.editarSolicitudObra.cerrar()"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="$refs.editarSolicitudObra.mixActualizarSolicitudObra()"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Ventana Eliminar Solicitud Obra -->
    <v-dialog
      v-if="estaSolicitudObra"
      v-model="mostrarVentanaEliminarSolicitudObra"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-solicitud-obra
        :solicitudObraEliminar="estaSolicitudObra"
        v-on:cerrar="cerrarVentana">
      </eliminar-solicitud-obra>
    </v-dialog>
  </div>
</template>

<script>
import OBRAS_SOLICITUDES from '@/graphql/querys/administracion/obrassolicitudes/obrasSolicitudes.gql';
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import CustomButton from '@/components/buttons/Button.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import AgregarSolicitudObra from '@/components/administracion/solicitudesobras/Nueva.vue';
import EditarSolicitudObra from '@/components/administracion/solicitudesobras/Editar.vue';
import EliminarSolicitudObra from '@/components/administracion/solicitudesobras/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';

export default {
  name: 'AdjudicacionesDefault',
  components: {
    CustomButton,
    TituloToolBar,
    AgregarSolicitudObra,
    EditarSolicitudObra,
    EliminarSolicitudObra,
    ToolBar,
    Listado,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      mostrarVentanaRegistrarNuevaSolicitudObra: false,
      mostrarVentanaEditarSolicitudObra: false,
      mostrarVentanaEliminarSolicitudObra: false,
      estaSolicitudObra: null,
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscarTexto: '',
      },
    };
  },
  apollo: {
    obrasSolicitudes: {
      query: OBRAS_SOLICITUDES,
    },
    firmasPorModulo: {
      query: FIRMAS_POR_MODULO,
      variables() {
        return {
          modulo: 'obrassolicitudes',
        };
      },
    },
  },
  mounted() {
    eventBus.$on('editar-solicitud-obra', (solicitudObra) => {
      this.estaSolicitudObra = solicitudObra;
      this.mostrarVentanaEditarSolicitudObra = true;
    });
    eventBus.$on('eliminar-solicitud-obra', (solicitudObra) => {
      this.estaSolicitudObra = solicitudObra;
      this.mostrarVentanaEliminarSolicitudObra = true;
    });
  },
  methods: {
    setFormularioValido(valor) {
      this.formularioValido = valor;
    },
    setEnviandoFormulario(valor) {
      this.enviandoFormulario = valor;
    },
    registrarNuevaSolicitudObra() {
      this.mostrarVentanaRegistrarNuevaSolicitudObra = true;
      this.enviandoFormulario = false;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevaSolicitudObra = false;
      this.mostrarVentanaEditarSolicitudObra = false;
      this.mostrarVentanaEliminarSolicitudObra = false;
      this.enviandoFormulario = false;
      this.formularioValido = false;
      this.estaSolicitudObra = null;
    },
  },
  computed: {
    getFirmaSolicitudObra() {
      if (!this.firmasPorModulo || this.firmasPorModulo.length < 1) return {};
      return this.firmasPorModulo[0];
    },
    getSolicitudesObras() {
      if (!this.obrasSolicitudes) return [];
      return this.obrasSolicitudes;
    },
    getListadoSolicitudesObras() {
      if (!this.obrasSolicitudes) return [];
      return this.obrasSolicitudes
        // Agregar Ejercicio
        .map((solicitudObra) => ({
          ...solicitudObra,
          ejercicio: new Date(solicitudObra.fechaOficioSolicitud).getFullYear(),
        }))
        .slice()
        .sort((a, b) => new Date(a.fechaOficioSolicitud) - new Date(b.fechaOficioSolicitud))
        // Filtrar por Ejercicio
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        // Filtrar por texto
        .filter((solicitudObra) => {
          if (!this.filtros.buscarTexto) return solicitudObra;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numeroMemorandum = this.$normalizacionTexto(solicitudObra.numeroMemorandum);
          const meta = this.$normalizacionTexto(solicitudObra.meta);
          return (
            expt.test(numeroMemorandum)
          || expt.test(meta)
          || expt.test(solicitudObra.numeroMemorandum)
          || expt.test(solicitudObra.meta)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
